import { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import Button from "../components/Button";
import { editForward, editRequest, updateUnique, jumpToState } from "../actions/studensts";
import AlertDenger from "../components/AlertDenger";
import AlertSuccess from "../components/AlertSuccess";
import Loading from "../components/Loading";
import Input from "../components/Input";
import { compressAccurately } from "image-conversion";
import { ACT_SUBJECTS, ACT1_SUBJECTS, EXAM_NAMES, GRADE_LEVELS, ScchoolNames } from "../constants/subjects-list";
export default function Edit() {
  const safeValue = (value) => {
    return value === null || value === undefined ? "" : value;
  };
  const user = JSON.parse(localStorage.getItem("profile"));
  const state = useLocation().state;
  const pathname = useLocation().pathname.split("/")[3];
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showDengerAlert, setShowDengerAlert] = useState(false);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);


  // For ACT1 Matching Certificate: always use 2 trials
  const matchingTrialCount = 2;
  const superScoreTrialCount = 1;

  // Helper to group flat act1_scores array into trials with subjects
  function groupAct1Scores(flatScores) {
    console.log('Processing act1_scores:', flatScores);

    if (!Array.isArray(flatScores) || flatScores.length === 0) {
      console.log('No scores to process');
      return [];
    }

    // Define the correct subject order
    const SUBJECT_ORDER = ['English', 'Reading', 'Math', 'Science'];

    // Group scores by trial_no
    const groupedByTrial = new Map();

    flatScores.forEach(score => {
      console.log('Processing score:', score);

      const trialNo = Number(score.trial_no) || 1;
      if (!groupedByTrial.has(trialNo)) {
        groupedByTrial.set(trialNo, {
          trial_no: trialNo,
          trial_id: score.trial_id || "",
          trial_date: score.trial_date || "",
          total_score: score.total_score || "",
          exam_row_id: score.exam_row_id || null,
          subjects: []
        });
      }

      const trial = groupedByTrial.get(trialNo);

      // Add subject if it has a name
      if (score.subject_name) {
        const existingSubject = trial.subjects.find(
          s => s.subject_name === score.subject_name
        );

        if (!existingSubject) {
          trial.subjects.push({
            subject_name: score.subject_name,
            subject_score: score.subject_score || "",
            subject_date: score.subject_date || "",
            trial_date: score.trial_date || "",
            exam_row_id: score.exam_row_id || null
          });
        }
      }
    });

    // Sort subjects within each trial by the correct order
    groupedByTrial.forEach((trial) => {
      trial.subjects.sort((a, b) => {
        const orderA = SUBJECT_ORDER.indexOf(a.subject_name);
        const orderB = SUBJECT_ORDER.indexOf(b.subject_name);
        // If subject not found in order array, put it at the end
        return (orderA === -1 ? 999 : orderA) - (orderB === -1 ? 999 : orderB);
      });
    });

    // Convert to array and sort by trial_no
    const sortedTrials = Array.from(groupedByTrial.values())
      .sort((a, b) => a.trial_no - b.trial_no);

    // Ensure each trial has at least 4 subjects
    const processedTrials = sortedTrials.map(trial => ({
      ...trial,
      subjects: trial.subjects.length >= 4 ? trial.subjects :
        [
          ...trial.subjects,
          ...Array(4 - trial.subjects.length).fill(0).map(() => ({
            subject_name: "",
            subject_score: "",
            subject_date: "",
            trial_date: trial.trial_date || "",
            exam_row_id: trial.exam_row_id
          }))
        ]
    }));

    console.log('Processed trials:', processedTrials);
    return processedTrials;
  }

  // Initialize scores with proper structure and preserve existing data
  let initialScores;
  console.log('Initializing scores with state:', {
    act1_scores: state?.act1_scores,
    exam_name: state?.exam_name,
    exam_row_id: state?.act1_exam_row_id,
    act1_trydate1: state?.act1_try_date1,
    // Debug: Check if backend is sending the trial date fields
    act1_try_date1: state?.act1_try_date1,
    act1_try_date2: state?.act1_try_date2,
    act1_try_date3: state?.act1_try_date3,
    act1_try_date4: state?.act1_try_date4,
    act1_try_date5: state?.act1_try_date5,

    act1_try1_id: state?.act1_try1_id,
    act1_try2_id: state?.act1_try2_id,
    act1_try3_id: state?.act1_try3_id,
    act1_try4_id: state?.act1_try4_id,
    act1_try5_id: state?.act1_try5_id,
    backend_state: state // Log the entire state object to see what's coming from backend
  });

  // Function to create empty trial structure
  const createEmptyTrial = (trialNo, examRowId) => ({
    trial_no: trialNo,
    trial_id: "",
    trial_date: "",
    total_score: "",
    exam_row_id: examRowId,
    subjects: Array.from({ length: 4 }, () => ({
      subject_name: "",
      subject_score: "",
      subject_date: "",
      trial_date: "",
      exam_row_id: examRowId
    }))
  });

  if (state?.act1_scores?.length > 0) {
    console.log('Processing act1_scores for initialization');
    const processedScores = groupAct1Scores(state.act1_scores);

    if (state?.exam_name === "ACT1 Matching Certificate") {
      initialScores = processedScores.slice(0, 2);
      while (initialScores.length < 2) {
        initialScores.push(createEmptyTrial(initialScores.length + 1, state.act1_exam_row_id));
      }
    } else if (state?.exam_name === "ACT1 Super Score Certificate") {
      initialScores = [processedScores[0] || createEmptyTrial(1, state.act1_exam_row_id)];
      // Remove the problematic code that was overriding subject_date with trial_date
      // The subject_date should remain as retrieved from the database
    } else {
      // One Trial Certificate
      initialScores = [processedScores[0] || createEmptyTrial(1, state.act1_exam_row_id)];
    }
  } else {
    console.log('Creating empty score structure');
    const trialCount = state?.exam_name === "ACT1 Matching Certificate" ? 2 : 1;
    initialScores = Array.from({ length: trialCount }, (_, i) =>
      createEmptyTrial(i + 1, state?.act1_exam_row_id)
    );
  }

  console.log('Initialized scores:', initialScores);

  const [studentData, setStudentData] = useState({
    university: "",
    ...state,
    old_id: state?.id || "",
    edited_user: user.value[0].username,
    request_edit_user: user.value[0].username,
    image_letter: "",
    image_id: "",
    scores: initialScores,
    // Ensure these fields are initialized
    id: state?.id || "",
    date_of_birth: state?.date_of_birth || "",
    dateMatchesId: true, // Initialize validation state

    // Explicitly initialize ACT1 trial dates and IDs from backend
    act1_try_date1: state?.act1_try_date1 || "",
    act1_try_date2: state?.act1_try_date2 || "",
    act1_try_date3: state?.act1_try_date3 || "",
    act1_try_date4: state?.act1_try_date4 || "",
    act1_try_date5: state?.act1_try_date5 || "",
    act1_try1_id: state?.act1_try1_id || "",
    act1_try2_id: state?.act1_try2_id || "",
    act1_try3_id: state?.act1_try3_id || "",
    act1_try4_id: state?.act1_try4_id || "",
    act1_try5_id: state?.act1_try5_id || "",
    act1_score1: state?.act1_score1 || "",
    act1_score2: state?.act1_score2 || "",
    act1_score3: state?.act1_score3 || "",
  });
  console.log({ 'Id': state?.id, 'DOB': state?.date_of_birth });

  // Sync scores from state if they change (e.g., loaded async)
  // Sync scores from state if they change
  useEffect(() => {
    // console.log('Score sync effect triggered', {
    //   act1_scores: state?.act1_scores,
    //   exam_name: state?.exam_name,
    //   exam_row_id: state?.act1_exam_row_id
    // });

    const createEmptyTrial = (trialNo, examRowId) => ({
      trial_no: trialNo,
      trial_id: "",
      trial_date: "",
      total_score: "",
      exam_row_id: examRowId,
      subjects: Array.from({ length: 4 }, () => ({
        subject_name: "",
        subject_score: "",
        subject_date: "",
        trial_date: "",
        exam_row_id: examRowId
      }))
    });

    if (Array.isArray(state?.act1_scores)) {
      console.log('Processing act1_scores for state update');
      const groupedScores = groupAct1Scores(state.act1_scores);

      let processedScores;
      switch (state?.exam_name) {
        case "ACT1 Matching Certificate":
          processedScores = groupedScores.slice(0, 2);
          while (processedScores.length < 2) {
            processedScores.push(createEmptyTrial(processedScores.length + 1, state.act1_exam_row_id));
          }
          break;

        case "ACT1 Super Score Certificate":
          processedScores = [groupedScores[0] || createEmptyTrial(1, state.act1_exam_row_id)];
          // Don't override subject_date with trial_date - preserve the database values
          break;

        default: // One Trial Certificate
          processedScores = [groupedScores[0] || createEmptyTrial(1, state.act1_exam_row_id)];
          break;
      }

      console.log('Setting processed scores:', processedScores);
      setStudentData(prev => ({
        ...prev,
        scores: processedScores
      }));
    }
  }, [state?.act1_scores, state?.exam_name, state?.act1_exam_row_id]);

  // Handle exam name changes with proper trial count initialization
  useEffect(() => {
    // Skip if no exam name selected
    if (!studentData.exam_name) {
      return;
    }

    // Process existing act1_scores if available
    if (state?.act1_scores?.length > 0 && studentData.exam_name !== state?.exam_name) {
      const processedScores = groupAct1Scores(state.act1_scores);
      let newScores = [];

      switch (studentData.exam_name) {
        case "ACT1 Matching Certificate":
          // Take up to 2 trials for matching certificate
          newScores = processedScores.slice(0, 2);
          while (newScores.length < 2) {
            newScores.push({
              trial_no: newScores.length + 1,
              trial_id: "",
              trial_date: "",
              total_score: "",
              subjects: Array.from({ length: 4 }, () => ({
                subject_name: "",
                subject_score: "",
                subject_date: "",
                trial_date: ""
              }))
            });
          }
          break;

        case "ACT1 Super Score Certificate":
          // Take the latest trial for super score
          newScores = processedScores.slice(0, 1);
          // Don't override subject_date with trial_date - preserve the database values
          break;

        case "ACT1 One Trial Certificate":
          // Take just one trial
          newScores = processedScores.slice(0, 1);
          break;

        default:
          newScores = processedScores.slice(0, 1);
      }

      // Update state with processed scores
      setStudentData(prev => ({
        ...prev,
        scores: newScores
      }));
      return;
    }

    // If no act1_scores or same exam name, just initialize with empty trials
    if (studentData.exam_name === state?.exam_name) {
      return;
    }

    // Determine number of trials based on exam type
    const trialCount = studentData.exam_name === "ACT1 Matching Certificate"
      ? matchingTrialCount
      : superScoreTrialCount;

    // Create empty trials with the determined count
    const emptyTrials = Array.from({ length: trialCount }, (_, i) => ({
      trial_no: i + 1,
      trial_id: "",
      trial_date: "",
      total_score: "",
      subjects: Array.from({ length: 4 }, () => ({
        subject_name: "",
        subject_score: "",
        subject_date: "",
        trial_date: ""
      }))
    }));

    // Update state with empty trials
    setStudentData(prev => ({
      ...prev,
      scores: emptyTrials
    }));

  }, [studentData.exam_name, state?.exam_name, matchingTrialCount, superScoreTrialCount, state?.act1_scores]);
  const pathname_two = useLocation().pathname.split("/")[3];

  if (showSuccessAlert || showDengerAlert) {
    setTimeout(function () {
      setShowSuccessAlert(false);
      setShowDengerAlert(false);
      setLoading(false);
      if (pathname === "new") {
        // navigate("/main/invoice/new");
      } else if (pathname === "request_edit") {
        // navigate("/main/auditing/request_edit");
      }
    }, 3000);
  }

  // Update trial-level fields (total_score, trial_date, trial_id)
  const handleTrialChange = (trialIndex, field, value) => {
    setStudentData((prev) => {
      const updatedScores = [...(prev.scores || [])];
      updatedScores[trialIndex] = {
        ...updatedScores[trialIndex],
        [field]: field === 'total_score'
          ? (value === '' ? '' : parseInt(value) || updatedScores[trialIndex].total_score || '')
          : value,
      };

      console.log(`Updated ${field} for trial ${trialIndex + 1}:`, {
        field: field,
        value: value,
        trialIndex: trialIndex,
        updatedTrial: updatedScores[trialIndex]
      });

      return { ...prev, scores: updatedScores };
    });
  };

  const handleSubjectChange = (trialIndex, subjectIndex, field, value) => {
    setStudentData(prev => {
      const updatedScores = [...prev.scores];
      const trial = updatedScores[trialIndex];
      const updatedSubjects = [...trial.subjects];
      let newSubject = { ...updatedSubjects[subjectIndex], [field]: value };

      // Always sync trial_date for ACT1 One Trial Certificate
      if (prev.exam_name === "ACT1 One Trial Certificate") {
        newSubject.trial_date = trial.trial_date;
      }

      // For subject_date field, ensure it's properly set
      if (field === 'subject_date') {
        newSubject.subject_date = value;
        console.log('Setting subject_date:', value);
      }

      updatedSubjects[subjectIndex] = newSubject;
      updatedScores[trialIndex] = {
        ...trial,
        subjects: updatedSubjects
      };

      console.log('Updated subject:', newSubject);
      return { ...prev, scores: updatedScores };
    });
  };
  // Add a new subject to a trial
  const handleAddSubject = (trialIndex) => {
    setStudentData((prev) => {
      const updatedScores = [...(prev.scores || [])].map((trial, index) => {
        if (index !== trialIndex) return trial;

        const newSubject = {
          subject_name: "",
          subject_score: "",
          subject_date: "",
          trial_date: prev.exam_name === "ACT1 One Trial Certificate" ? trial.trial_date : ""
        };

        return {
          ...trial,
          subjects: [
            ...(trial.subjects || []),
            newSubject
          ]
        };
      });

      return { ...prev, scores: updatedScores };
    });
  };

  // Remove a subject from a trial
  const handleRemoveSubject = (trialIndex, subjectIndex) => {
    setStudentData((prev) => {
      const updatedScores = [...(prev.scores || [])].map((trial, tIndex) => {
        if (tIndex !== trialIndex) return trial;

        return {
          ...trial,
          subjects: (trial.subjects || []).filter((_, sIndex) => sIndex !== subjectIndex)
        };
      });

      return { ...prev, scores: updatedScores };
    });
  };

  // Default structure for trials with dynamic subjects count
  const initializeDefaultTrials = (maxSubjects = 4) => {
    return Array.from({ length: 3 }, (_, trialIndex) => ({
      trial_no: trialIndex + 1,
      total_score: "",
      trial_date: "",
      trial_id: "",
      subjects: Array.from({ length: maxSubjects }, () => ({
        subject_name: "",
        subject_score: "",
        subject_date: "",
        trial_date: "",
      })),
    }));
  };

  const DEFAULT_TRIALS = initializeDefaultTrials();

  // Always render scores safely (fallback to default structure)
  // If we have scores with subjects, use their maximum subject count
  const maxSubjectsInScores = studentData.scores?.reduce((max, trial) =>
    Math.max(max, trial.subjects?.length || 0), 0) || 4;

  const scoresToRender = studentData.scores?.length
    ? studentData.scores
    : initializeDefaultTrials(Math.max(4, maxSubjectsInScores));


  // Function to extract date from Egyptian National ID
  const extractDateFromNationalId = (nationalId) => {
    if (!nationalId || nationalId.length !== 14) {
      console.log("Invalid National ID length");
      return null;
    }

    const centuryDigit = nationalId[0];
    let year = nationalId.substring(1, 3);
    const month = nationalId.substring(3, 5);
    const day = nationalId.substring(5, 7);

    // Validate century
    let century;
    if (centuryDigit === "2") {
      century = "19";
    } else if (centuryDigit === "3") {
      century = "20";
    } else {
      console.log("Invalid century digit in National ID:", centuryDigit);
      return null;
    }

    year = century + year;

    // Validate month/day
    const monthNum = parseInt(month, 10);
    const dayNum = parseInt(day, 10);

    if (monthNum < 1 || monthNum > 12) {
      console.log("Invalid month in national ID:", { month, monthNum });
      return null;
    }

    const daysInMonth = new Date(year, monthNum, 0).getDate();
    if (dayNum < 1 || dayNum > daysInMonth) {
      console.log("Invalid day in national ID:", { day, dayNum, monthNum, daysInMonth });
      return null;
    }

    const formattedMonth = monthNum.toString().padStart(2, "0");
    const formattedDay = dayNum.toString().padStart(2, "0");

    const formattedDate = `${year}-${formattedMonth}-${formattedDay}`;
    console.log("Successfully extracted date from National ID:", formattedDate);

    return formattedDate;
  };


  /*  Function to validate date of birth against national ID
  const validateDateOfBirth = (nationalId, dateOfBirth) => {
    // Return true if either value is missing
    if (!nationalId || !dateOfBirth) return true;
    
    const extractedDate = extractDateFromNationalId(nationalId);
    if (!extractedDate) return true; // Return true if we can't extract date
    
    try {
      // Convert date of birth to YYYY-MM-DD format
      const dob = new Date(dateOfBirth);
      const formattedDOB = dob.toISOString().split('T')[0];
      
      console.log('Comparing dates:', {
        extractedDate,
        formattedDOB,
        nationalId,
        dateOfBirth
      });
      
      // Compare the dates
      return formattedDOB === extractedDate;
    } catch (error) {
      console.error('Error validating date:', error);
      return true; // Return true on error to avoid blocking submission
    }
  };
*/

  const handleClick = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log('Original studentData scores:', studentData.scores);
      console.log('SSC Trial Data:', {
        act1: studentData.act1,
        act1_score1: studentData.act1_score1,
        act1_try_date1: studentData.act1_try_date1,
        act1_try1_id: studentData.act1_try1_id,
        act1_try_date2: studentData.act1_try_date2,
        act1_try2_id: studentData.act1_try2_id,
        act1_try_date3: studentData.act1_try_date3,
        act1_try3_id: studentData.act1_try3_id,
        act1_try_date4: studentData.act1_try_date4,
        act1_try4_id: studentData.act1_try4_id,
        act1_try_date5: studentData.act1_try_date5,
        act1_try5_id: studentData.act1_try5_id
      });

      // Prepare the normalized data ensuring SSC trial data is included
      const normalizedData = {
        ...studentData,
        // Ensure SSC trial data is explicitly included
        act1: studentData.act1 || false,
        act1_score1: studentData.act1_score1 || "",
        act1_try_date1: studentData.act1_try_date1 || "",
        act1_try1_id: studentData.act1_try1_id || "",
        act1_try_date2: studentData.act1_try_date2 || "",
        act1_try2_id: studentData.act1_try2_id || "",
        act1_try_date3: studentData.act1_try_date3 || "",
        act1_try3_id: studentData.act1_try3_id || "",
        act1_try_date4: studentData.act1_try_date4 || "",
        act1_try4_id: studentData.act1_try4_id || "",
        act1_try_date5: studentData.act1_try_date5 || "",
        act1_try5_id: studentData.act1_try5_id || "",
        scores: studentData.scores?.map(trial => {
          console.log('Processing trial:', trial);
          return {
            ...trial,
            subjects: trial.subjects?.map(subj => {
              console.log('Processing subject:', subj);
              return {
                ...subj,
                subject_date: subj.subject_date || "",  // Ensure subject_date is included
                trial_date: subj.trial_date || trial.trial_date || "" // Ensure trial_date is included
              };
            }).filter(subj =>
              subj.subject_name || subj.subject_score || subj.subject_date || subj.trial_date
            )
          };
        }).filter(trial =>
          trial.trial_id || trial.trial_date || trial.total_score ||
          (trial.subjects && trial.subjects.length > 0)
        )
      };

      // console.log('Normalized data being sent:', normalizedData);
      // console.log('SSC Trial data in normalized:', {
      //   act1: normalizedData.act1,
      //   act1_score1: normalizedData.act1_score1,
      //   act1_try_date1: normalizedData.act1_try_date1,
      //   act1_try1_id: normalizedData.act1_try1_id,
      //   act1_try_date2: normalizedData.act1_try_date2,
      //   act1_try2_id: normalizedData.act1_try2_id,
      //   act1_try_date3: normalizedData.act1_try_date3,
      //   act1_try3_id: normalizedData.act1_try3_id,
      //   act1_try_date4: normalizedData.act1_try_date4,
      //   act1_try4_id: normalizedData.act1_try4_id,
      //   act1_try_date5: normalizedData.act1_try_date5,
      //   act1_try5_id: normalizedData.act1_try5_id
      // });

      let res;
      if (pathname === "new") {
        // Save the student first
        console.log('About to call editForward with data:', normalizedData);
        res = await editForward(normalizedData);
        await updateUnique(normalizedData.old_id);

        // Extract DOB from national ID
        const extractedDob = extractDateFromNationalId(normalizedData.national_id);

        // Compare extracted DOB with studentData.date_of_birth (assuming YYYY-MM-DD format)
        const dateMatchesId = extractedDob && studentData.date_of_birth
          ? extractedDob === studentData.date_of_birth
          : true;

        studentData.dateMatchesId = dateMatchesId;

        // ✅ Condition: BOTH mismatch AND governmental university
        const needsAuditing =
          (studentData.id &&
            studentData.date_of_birth &&
            !dateMatchesId &&
            studentData.university &&
            studentData.university.toLowerCase() === 'governmental' && normalizedData.citizenship && normalizedData.citizenship.toLowerCase() === 'egyptian');

        if (needsAuditing && res.status === 200) {
          console.log("Moving to auditing_pending due to DOB mismatch AND governmental university");

          const jumpRes = await jumpToState(
            [studentData.id],
            "auditing_pending",
            user.value[0].username
          );

          if (jumpRes.status === 200) {
            setShowSuccessAlert(true);
            setText("Student forwarded to auditing pending due to date of birth mismatch and governmental university selection");
            return; // Exit early since we've already shown a success message
          }
        }
      } else if (pathname === "request_edit") {
        console.log('About to call editRequest with data:', normalizedData);
        res = await editRequest(normalizedData);
      }


      // Handle response
      if (res.status === 200) {
        setShowSuccessAlert(true);
        setText(res.data.message);
      } else {
        setShowDengerAlert(true);
        setText(res.data.ERROR || "An error occurred while saving");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setShowDengerAlert(true);
      setText(error.message || "An unexpected error occurred");
    } finally {
      setLoading(false);
    }
  };



  const handleInputChange = async (e) => {
    const target = e.target;
    let value;
    if (target.type === "checkbox") {
      value = target.checked;
    } else if (target.type === "file") {
      const file = target.files[0];
      const compressedImage = await compressAccurately(file, 100);
      value = await convertToBase64(compressedImage);
    } else {
      value = target.value;
    }

    const name = target.name;
    const newStudentData = { ...studentData, [name]: value };

    // Debug logging for SSC trial fields
    if (name.startsWith('act1_try_date') || name.startsWith('act1_try') && name.endsWith('_id') || name === 'act1_score1' || name === 'act1') {
      console.log('SSC Trial field updated:', {
        fieldName: name,
        newValue: value,
        currentData: {
          act1: newStudentData.act1,
          act1_score1: newStudentData.act1_score1,
          act1_try_date1: newStudentData.act1_try_date1,
          act1_try1_id: newStudentData.act1_try1_id,
          act1_try_date2: newStudentData.act1_try_date2,
          act1_try2_id: newStudentData.act1_try2_id,
          act1_try_date3: newStudentData.act1_try_date3,
          act1_try3_id: newStudentData.act1_try3_id,
          act1_try_date4: newStudentData.act1_try_date4,
          act1_try4_id: newStudentData.act1_try4_id,
          act1_try_date5: newStudentData.act1_try_date5,
          act1_try5_id: newStudentData.act1_try5_id
        }
      });
    }

    // Special handling for ID and date_of_birth fields
    if (name === 'id' || name === 'date_of_birth') {
      console.log('Validating input:', {
        field: name,
        id: newStudentData.id,
        dob: newStudentData.date_of_birth
      });

      // Clear any previous validation state if either field is empty
      if (!newStudentData.id || !newStudentData.date_of_birth) {
        newStudentData.dateMatchesId = true; // Reset validation state
        if (showDengerAlert) {
          setShowDengerAlert(false);
        }
      }
      // Validate when both fields are present
      else {
        const idDate = extractDateFromNationalId(newStudentData.id);

        if (idDate) {
          try {
            // Parse and format the input date
            const inputDate = new Date(newStudentData.date_of_birth);
            if (isNaN(inputDate.getTime())) {
              throw new Error('Invalid date format');
            }

            // Adjust for timezone offset
            const offset = inputDate.getTimezoneOffset();
            inputDate.setMinutes(inputDate.getMinutes() - offset);
            const formattedInputDate = inputDate.toISOString().split('T')[0];

            console.log('Comparing dates:', {
              fromId: idDate,
              fromInput: formattedInputDate
            });

            if (formattedInputDate !== idDate) {
              setShowDengerAlert(true);
              setText(`Date mismatch detected.\nNational ID indicates: ${idDate}\nEntered date: ${formattedInputDate}\n\n This will forward student to Auditing - Pending.`);
              newStudentData.dateMatchesId = false;
            } else {
              newStudentData.dateMatchesId = true;
              if (showDengerAlert) {
                setShowDengerAlert(false);
              }
              console.log('Dates match successfully');
            }
          } catch (error) {
            console.error('Error validating date:', error);
            setShowDengerAlert(true);
            setText('Invalid date format. Please enter a valid date.');
            newStudentData.dateMatchesId = false;
          }
        }
        // Note: If idDate is null, the extractDateFromNationalId function will have already shown an error
      }
    }

    setStudentData(newStudentData);
  };

  const handleSchoolsChange = (e) => {
    const { name, value } = e.target;

    setStudentData((prev) => {
      if (name === 'school_name') {
        // Find the record(s) for this school name
        const matches = ScchoolNames.filter(s => s.scvalue === value);
        // If there are multiple campuses with same name, prefer one that matches current city
        let rec = matches[0] || null;
        if (prev.school_city && matches.length > 1) {
          const byCity = matches.find(s => s.scivalue === prev.school_city);
          if (byCity) rec = byCity;
        }

        return {
          ...prev,
          school_name: value,
          school_city: rec?.scivalue || '',
          school_country: rec?.scountryvalue || '',
        };
      }

      if (name === 'school_city') {
        // If city changes, try to align country using school+city match or any by city
        const rec =
          ScchoolNames.find(s => s.scvalue === prev.school_name && s.scivalue === value) ||
          ScchoolNames.find(s => s.scivalue === value);

        return {
          ...prev,
          school_city: value,
          school_country: rec?.scountryvalue || prev.school_country || '',
        };
      }

      if (name === 'school_country') {
        return { ...prev, school_country: value };
      }

      return { ...prev, [name]: value };
    });
  };

  return (
    <div className="flex justify-center">
      <div
        className="lg:w-4/5 font-serif shadow-2xl opacity-90	 md:w-3/4 w-full min-h-screen border shadow
    flex flex-col bg-slate-300 p-2 rounded-lg"
      >
        {showSuccessAlert && <AlertSuccess text={text} />}
        {showDengerAlert && <AlertDenger text={text} />}
        <form onSubmit={handleClick} action="submit" className="m-3 border rounded-md p-3 shadow">
          <div className="p-1 ">
            <Input
              type="text"
              placeholder="Full Name"
              name="full_name"
              onChange={handleInputChange}
              value={safeValue(studentData.full_name)}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            <Input
              type="text"
              placeholder="First Name"
              name="first_name"
              onChange={handleInputChange}
              value={safeValue(studentData.first_name)}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            <Input
              type="text"
              placeholder="Middle 1 Name"
              name="middle1_name"
              onChange={handleInputChange}
              value={safeValue(studentData.middle1_name)}
              required={false}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            <Input
              type="text"
              placeholder="Middle 2 Name"
              name="middle2_name"
              onChange={handleInputChange}
              value={safeValue(studentData.middle2_name)}
              required={false}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            <Input
              type="text"
              placeholder="Last Name"
              name="last_name"
              onChange={handleInputChange}
              value={safeValue(studentData.last_name)}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            {pathname_two === "new" ? (
              <Input type="text" placeholder="National ID" name="id" disabled onChange={handleInputChange} value={safeValue(studentData.id)} />
            ) : (
              <Input type="text" placeholder="National ID" name="id" onChange={handleInputChange} value={safeValue(studentData.id)} />
            )}

            <Input type="text" placeholder="Passport Number" name="passport_number" required={false} onChange={handleInputChange} value={safeValue(studentData.passport_number)} />
            <Input type="text" placeholder="ACT ID" name="act1_id" onChange={handleInputChange} value={safeValue(studentData.act1_id)} />
            <Input type="text" placeholder="ACT Subject ID" name="act2_id" onChange={handleInputChange} required={false} value={safeValue(studentData.act2_id)} />
            <Input type="text" placeholder="Email" name="email" onChange={handleInputChange} value={safeValue(studentData.email)} />
            <Input type="text" placeholder="Phone" name="phone" onChange={handleInputChange} value={safeValue(studentData.phone)} />
            <div className="relative">
              <Input
                type="date"
                placeholder="Date of Birth"
                name="date_of_birth"
                onChange={handleInputChange}
                value={safeValue(studentData.date_of_birth)}
                title="Date of birth must match the one in your National ID"
                className={studentData.dateMatchesId === false ? "border-red-500" : ""}
              />
            </div>
            <Input type="text" placeholder="City" name="address" onChange={handleInputChange} value={safeValue(studentData.address)} pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$" title="Please enter english language only" />
            <Input type="text" placeholder="Country" name="postal_code" onChange={handleInputChange} value={safeValue(studentData.postal_code)} />
            <div className="m-2 flex items-center justify-center">
              <label htmlFor="name" className="flex-auto">
                <span className="text-red-600">*</span>
                Gender:
              </label>
              <div className="flex-1 flex items-center justify-between">
                <div className="flex gap-1">
                  <input type="radio" name="gender" value="male" required onChange={handleInputChange} checked={studentData.gender === "male"} />
                  <label htmlFor="male">Male</label>
                </div>
                <div className="flex gap-1">
                  <input type="radio" name="gender" value="female" onChange={handleInputChange} checked={studentData.gender === "female"} />
                  <label htmlFor="female">Female</label>
                </div>
              </div>
            </div>

            <div className="m-2 flex items-center justify-center">
              <label htmlFor="name" className="flex-auto">
                <span className="text-red-600">*</span>
                University:
              </label>
              <div className="flex-1 flex items-center justify-between">
                <div className="flex gap-1">
                  <input
                    type="radio"
                    name="university"
                    value="governmental"
                    required
                    onChange={handleInputChange}
                    checked={studentData.university === "governmental"}
                  />
                  <label htmlFor="governmental">Governmental</label>
                </div>
                <div className="flex gap-1">
                  <input
                    type="radio"
                    name="university"
                    value="private"
                    onChange={handleInputChange}
                    checked={studentData.university === "private"}
                  />
                  <label htmlFor="both">Private</label>
                </div>
                <div className="flex gap-1">
                  <input
                    type="radio"
                    name="university"
                    value="both"
                    onChange={handleInputChange}
                    checked={studentData.university === "both"}
                  />
                  <label htmlFor="both">Both</label>
                </div>
              </div>
            </div>
            <div className="m-2 flex items-center justify-center">
              <div className="flex-1 flex items-center justify-between p-1 m-1 border border-gray-400 rounded-md">
                <label htmlFor="collegeName1" className="flex-auto">
                  <span className="text-red-600">*</span>
                  College Name 1:
                </label>
                <div className="flex gap-1">
                  <input
                    type="text"
                    name="collegeName1"
                    value={safeValue(studentData.collegeName1)}
                    onChange={handleInputChange}
                    placeholder="Enter College Name"
                    required
                  />
                </div>
              </div>

              <div className="flex-1 flex items-center justify-between p-1 m-1 border border-gray-400 rounded-md">
                <label htmlFor="colabbreviation1" className="flex-auto">
                  <span className="text-red-600">*</span>
                  Abbreviation:
                </label>
                <div className="flex gap-1">
                  <input
                    type="text"
                    name="colabbreviation1"
                    value={safeValue(studentData.colabbreviation1)}
                    onChange={handleInputChange}
                    placeholder="Enter College Abbreviation"
                    required
                  />
                </div>
              </div>
            </div>
            <div className="m-2 flex items-center justify-center">
              <div className="flex-1 flex items-center justify-between p-1 m-1 border border-gray-400 rounded-md">
                <label htmlFor="collegeName2" className="flex-auto">
                  College Name 2:
                </label>
                <div className="flex gap-1">
                  <input
                    type="text"
                    name="collegeName2"
                    value={safeValue(studentData.collegeName2)}
                    onChange={handleInputChange}
                    placeholder="Enter College Name"
                  />
                </div>
              </div>

              <div className="flex-1 flex items-center justify-between p-1 m-1 border border-gray-400 rounded-md">
                <label htmlFor="colabbreviation2" className="flex-auto">
                  Abbreviation:
                </label>
                <div className="flex gap-1">
                  <input
                    type="text"
                    name="colabbreviation2"
                    value={safeValue(studentData.colabbreviation2)}
                    onChange={handleInputChange}
                    placeholder="Enter College Abbreviation"
                  />
                </div>
              </div>
            </div>
            <div className="m-2 flex items-center justify-center">
              <div className="flex-1 flex items-center justify-between p-1 m-1 border border-gray-400 rounded-md">
                <label htmlFor="collegeName3" className="flex-auto">
                  College Name 3:
                </label>
                <div className="flex gap-1">
                  <input
                    type="text"
                    name="collegeName3"
                    value={safeValue(studentData.collegeName3)}
                    onChange={handleInputChange}
                    placeholder="Enter College Name"
                  />
                </div>
              </div>

              <div className="flex-1 flex items-center justify-between p-1 m-1 border border-gray-400 rounded-md">
                <label htmlFor="colabbreviation3" className="flex-auto">
                  Abbreviation:
                </label>
                <div className="flex gap-1">
                  <input
                    type="text"
                    name="colabbreviation3"
                    value={safeValue(studentData.colabbreviation3)}
                    onChange={handleInputChange}
                    placeholder="Enter College Abbreviation"
                  />
                </div>
              </div>
            </div>
            <div className="m-2 flex items-center justify-center">
              <div className="flex-1 flex items-center justify-between p-1 m-1 border border-gray-400 rounded-md">
                <label htmlFor="collegeName4" className="flex-auto">
                  College Name 4:
                </label>
                <div className="flex gap-1">
                  <input
                    type="text"
                    name="collegeName4"
                    value={safeValue(studentData.collegeName4)}
                    onChange={handleInputChange}
                    placeholder="Enter College Name"
                  />
                </div>
              </div>

              <div className="flex-1 flex items-center justify-between p-1 m-1 border border-gray-400 rounded-md">
                <label htmlFor="colabbreviation4" className="flex-auto">
                  Abbreviation:
                </label>
                <div className="flex gap-1">
                  <input
                    type="text"
                    name="colabbreviation4"
                    value={safeValue(studentData.colabbreviation4)}
                    onChange={handleInputChange}
                    placeholder="Enter College Abbreviation"
                  />
                </div>
              </div>
            </div>
            <div className="m-2 flex items-center justify-center">
              {/* Input field for entering college name */}
              <div className="flex-1 flex items-center justify-between p-1 m-1 border border-gray-400 rounded-md">
                <label htmlFor="collegeName5" className="flex-auto">
                  College Name 5:
                </label>
                <div className="flex gap-1">
                  <input
                    type="text"
                    name="collegeName5"
                    value={safeValue(studentData.collegeName5)}
                    onChange={handleInputChange}
                    placeholder="Enter College Name"
                  />
                </div>
              </div>

              {/* Input field for entering abbreviation */}
              <div className="flex-1 flex items-center justify-between p-1 m-1 border border-gray-400 rounded-md">
                <label htmlFor="colabbreviation5" className="flex-auto">
                  Abbreviation:
                </label>
                <div className="flex gap-1">
                  <input
                    type="text"
                    name="colabbreviation5"
                    value={safeValue(studentData.colabbreviation5)}
                    onChange={handleInputChange}
                    placeholder="Enter College Abbreviation"
                  />
                </div>
              </div>
            </div>
            <div className="flex-1 flex items-center justify-between p-1 m-1 border border-gray-400 rounded-md">
              <label htmlFor="specialization1" className="flex-auto">
                <span className="text-red-600">*</span>
                Specialization 1:
              </label>
              <div className="flex gap-1">
                <input
                  type="text"
                  name="specialization1"
                  value={safeValue(studentData.specialization1)}
                  onChange={handleInputChange}
                  placeholder="Enter Specialization"
                  required
                />
              </div>
            </div>
            <div className="flex-1 flex items-center justify-between p-1 m-1 border border-gray-400 rounded-md">
              <label htmlFor="specialization2" className="flex-auto">
                Specialization 2:
              </label>
              <div className="flex gap-1">
                <input
                  type="text"
                  name="specialization2"
                  value={safeValue(studentData.specialization2)}
                  onChange={handleInputChange}
                  placeholder="Enter Specialization"
                />
              </div>
            </div>
            <div className="flex-1 flex items-center justify-between p-1 m-1 border border-gray-400 rounded-md">
              <label htmlFor="specialization3" className="flex-auto">
                Specialization 3:
              </label>
              <div className="flex gap-1">
                <input
                  type="text"
                  name="specialization3"
                  value={safeValue(studentData.specialization3)}
                  onChange={handleInputChange}
                  placeholder="Enter Specialization"
                />
              </div>
            </div>
            <div className="flex-1 flex items-center justify-between p-1 m-1 border border-gray-400 rounded-md">
              <label htmlFor="studentyear" className="flex-auto">
                Student Year:
              </label>
              <div className="flex gap-1">
                <input
                  type="text"
                  name="studentyear"
                  value={safeValue(studentData.studentyear)}
                  onChange={handleInputChange}
                  placeholder="Enter Specialization"
                />
              </div>
            </div>
            <div className="flex-1 flex items-center justify-between p-1 border m-1 border-gray-400 rounded-md">
              <label htmlFor="schoolNum" className="flex-auto">
                School Num:
              </label>
              <div className="flex gap-1">
                <input
                  type="text"
                  name="schoolNum"
                  value={safeValue(studentData.schoolNum)}
                  onChange={handleInputChange}
                  placeholder="Enter Specialization"
                />
              </div>
            </div>
            <div className="m-2 flex items-center justify-center"> <label htmlFor="Schools" className="flex-auto"> School Name: </label><select
              value={safeValue(studentData.school_name)}
              name="school_name"
              onChange={handleSchoolsChange}
              className="border border-gray-300 rounded-md px-4 py-2 w-3/4"
            >
              <option value="">Select School Names</option>
              {ScchoolNames.map((s) => (
                <option key={`${s.scvalue}||${s.scivalue}`} value={s.scvalue}>
                  {s.sctext}
                </option>
              ))}
            </select>
            </div>
            <div className="m-2 flex items-center justify-center"> <label htmlFor="Schools" className="flex-auto"> School Country: </label>
              <select
                value={safeValue(studentData.school_country)}
                name="school_country"
                onChange={handleSchoolsChange}
                className="border border-gray-300 rounded-md px-4 py-2 w-3/4"
              >
                <option value="">Select School Countries</option>
                {[...new Set(ScchoolNames.map(s => s.scountryvalue))].map((country) => (
                  <option key={`country-${country}`} value={country}>
                    {country}
                  </option>
                ))}
              </select>
            </div>
            <div className="m-2 flex items-center justify-center"> <label htmlFor="Schools" className="flex-auto"> School City: </label>
              <select
                value={safeValue(studentData.school_city)}
                name="school_city"
                onChange={handleSchoolsChange}
                className="border border-gray-300 rounded-md px-4 py-2 w-3/4"
              >
                <option value="">Select School City</option>
                {[...new Set(ScchoolNames.map(s => s.scivalue))].map((city) => (
                  <option key={`city-${city}`} value={city}>
                    {city}
                  </option>
                ))}
              </select>
            </div>

            <Input
              type="text"
              placeholder="School Name"
              name="school_name"
              onChange={handleInputChange}
              value={safeValue(studentData.school_name)}
              title="Please enter english language only"
            />
            <Input
              type="text"
              placeholder="School Country"
              name="school_country"
              onChange={handleInputChange}
              value={safeValue(studentData.school_country)}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            <Input
              type="text"
              placeholder="School city"
              name="school_city"
              onChange={handleInputChange}
              value={safeValue(studentData.school_city)}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            <div className="m-2 flex items-center justify-center">
              <label htmlFor="category" className="flex-auto">
                Category:
              </label>
              <select
                name="category"
                value={safeValue(studentData.category)}
                onChange={handleInputChange}
                className="border border-gray-300 rounded-md px-4 py-2 w-3/4"
              >
                <option value="">Select Category</option>
                <option value="individual">Individual B</option>
                <option value="outside">Outside B</option>
                {/* <option value="inside">Inside</option> */}
                <option value="foreign">Foreign B</option>
                <option value="foreignUsd">Foreign In Dollar</option>
                <option value="individualA">Individual A</option>
                <option value="outsideA">Outside A</option>
                <option value="foreignA">Foreign A</option>
              </select>
            </div>
            <div className="m-2 flex items-center justify-center">
              <label htmlFor="Grade" className="flex-auto">
                Grade Level:
              </label>
              <select
                value={studentData.grade_status}
                name="grade_status"
                onChange={handleInputChange}
                // className="p-2 border rounded"
                className="border border-gray-300 rounded-md px-4 py-2 w-3/4"
              >
                <option value="">Select Grade</option>
                {GRADE_LEVELS.map((s) => (
                  <option key={s.value} value={s.value}>
                    {s.text}
                  </option>
                ))}
              </select>
            </div>

            <div className="relative">
              <Input
                type="date"
                placeholder="Enrolment Date"
                name="enrolment_date"
                onChange={handleInputChange}
                required={false}
                value={safeValue(studentData.enrolment_date)}
                title="The Enrolment Letter Date"
              />
            </div>

            <Input
              type="text"
              placeholder="Test Center Name"
              name="test_center_name"
              onChange={handleInputChange}
              required={false}
              value={safeValue(studentData.test_center_name)}
              pattern="^[a-zA-Z0-9\-\u0590-\u05FF ]+$"
              title="Please enter english language only"
            />
            <Input
              type="file"
              onChange={handleInputChange}
              placeholder="Upload Your ID"
              name="image_id"
              required={false}
            />
            <Input
              type="file"
              onChange={handleInputChange}
              placeholder="Upload Enrollment Letter"
              name="image_letter"
              required={false}
            />

            <div className="p-1 border rounded">
              <div className="m-2 flex items-center justify-center">
                <label htmlFor="Exam Name" className="flex-auto">
                  Exam Name:
                </label>
                <select
                  className="flex-initial p-2 ml-1 border rounded-xl focus:outline-blue-700"
                  onChange={handleInputChange}
                  name="exam_name"
                  value={safeValue(studentData.exam_name)}
                  required
                >
                  <option value=""> </option>
                  {EXAM_NAMES.map((subject, i) => (
                    <option value={subject} key={i}>
                      {subject}
                    </option>
                  ))}
                </select>
              </div>

              {studentData.exam_name === "ACT1 Super Score Certificate" && (
                <>
                  {(studentData.scores && studentData.scores.length > 0 ? studentData.scores : DEFAULT_TRIALS).map((trial, trialIndex) => (
                    <div key={trialIndex} className="flex-initial p-2 ml-1 border rounded-xl focus:outline-blue-700">
                      <div className="font-medium mb-2">Trial {trial.trial_no}</div>
                      <Input
                        type="number"
                        placeholder="Total Score"
                        value={trial.total_score || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "total_score", e.target.value)
                        }
                      />
                      <Input
                        type="date"
                        placeholder={`Trial Date ${trial.trial_no}`}
                        value={trial.trial_date || ""}
                        onChange={(e) => {
                          handleTrialChange(trialIndex, "trial_date", e.target.value);
                          setStudentData(prev => ({ ...prev, act1_try_date1: e.target.value }));
                        }}
                      />
                      <Input
                        type="text"
                        placeholder={`Trial ${trial.trial_no} Id`}
                        value={trial.trial_id || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "trial_id", e.target.value)
                        }
                      />
                      <div className="mt-2">
                        <div className="font-semibold mb-1">
                          Subjects for Trial {trial.trial_no}
                        </div>
                        {(trial.subjects ?? []).map((subject, subjIndex) => (
                          <div key={subjIndex} className="flex gap-2 items-center mb-2">
                            <select
                              value={subject.subject_name || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_name",
                                  e.target.value
                                )
                              }
                              className="p-2 border rounded"
                            >
                              <option value="">Select subject</option>
                              {ACT1_SUBJECTS.map((s) => (
                                <option key={s.value} value={s.value}>
                                  {s.text}
                                </option>
                              ))}
                            </select>
                            <Input
                              type="number"
                              placeholder="Subject score"
                              value={subject.subject_score || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_score",
                                  e.target.value
                                )
                              }
                              className="p-2 border rounded w-36"
                            />
                            <Input
                              type="date"
                              placeholder="Subject date"
                              value={subject.subject_date || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_date",
                                  e.target.value
                                )
                              }
                              className="p-2 border rounded w-36"
                            />
                            <button
                              type="button"
                              onClick={() => handleRemoveSubject(trialIndex, subjIndex)}
                              className="px-2 py-1 bg-red-500 text-white rounded"
                            >
                              Remove
                            </button>
                          </div>
                        ))}
                        <button
                          type="button"
                          onClick={() => handleAddSubject(trialIndex)}
                          className="mt-2 px-3 py-1 bg-blue-500 text-white rounded"
                        >
                          + Add Subject
                        </button>
                      </div>
                    </div>
                  ))}
                  <Input
                    type="number"
                    placeholder="Number of Copies "
                    name="act1_copy_number"
                    onChange={handleInputChange}
                    value={studentData.act1_copy_number}
                  />
                  <div class="m-2 flex items-center justify-center">
                    <Input
                      type="checkbox"
                      placeholder="SSC Trials"
                      name="act1"
                      required={false}
                      onChange={handleInputChange}
                      value={studentData.act1}
                    />
                  </div>
                  {studentData.act1 && (
                    <>
                      <Input
                        type="number"
                        placeholder="Score"
                        name="act1_score1"
                        required={false}
                        onChange={handleInputChange}
                        value={studentData.act1_score1}
                      />
                      <Input
                        type="date"
                        placeholder="Trial Date 1"
                        name="act1_try_date1"
                        required={false}
                        onChange={handleInputChange}
                        value={studentData.act1_try_date1}
                      />
                      <Input
                        type="text"
                        required={false}
                        placeholder="Trial 1 Id"
                        name="act1_try1_id"
                        onChange={handleInputChange}
                        value={studentData.act1_try1_id}
                      />
                      <Input
                        type="date"
                        placeholder="Trial Date 2"
                        required={false}
                        name="act1_try_date2"
                        onChange={handleInputChange}
                        value={studentData.act1_try_date2}
                      />
                      <Input
                        type="text"
                        placeholder="Trial 2 Id"
                        name="act1_try2_id"
                        onChange={handleInputChange}
                        required={false}
                        value={studentData.act1_try2_id}
                      />
                      <Input
                        type="date"
                        placeholder="Trial Date 3"
                        required={false}
                        name="act1_try_date3"
                        onChange={handleInputChange}
                        value={studentData.act1_try_date3}
                      />
                      <Input
                        type="text"
                        placeholder="Trial 3 Id"
                        name="act1_try3_id"
                        required={false}
                        onChange={handleInputChange}
                        value={studentData.act1_try3_id}
                      />
                      <Input
                        type="date"
                        placeholder="Trial Date 4"
                        required={false}
                        name="act1_try_date4"
                        onChange={handleInputChange}
                        value={studentData.act1_try_date4}
                      />
                      <Input
                        type="text"
                        placeholder="Trial 4 Id"
                        name="act1_try4_id"
                        onChange={handleInputChange}
                        required={false}
                        value={studentData.act1_try4_id}
                      />
                      <Input
                        type="date"
                        placeholder="Trial Date 5"
                        required={false}
                        name="act1_try_date5"
                        onChange={handleInputChange}
                        value={studentData.act1_try_date5}
                      />
                      <Input
                        type="text"
                        required={false}
                        placeholder="Trial 5 Id"
                        name="act1_try5_id"
                        onChange={handleInputChange}
                        value={studentData.act1_try5_id}
                      />
                    </>
                  )}
                </>
              )}
              {studentData.exam_name === "ACT1 Matching Certificate" && (
                <>
                  {studentData.scores.slice(0, 2).map((trial, trialIndex) => (
                    <div key={trialIndex} className="p-2 border rounded bg-slate-300 mb-2">
                      <div className="font-medium mb-2">Trial {trial.trial_no}</div>

                      <Input
                        type="number"
                        placeholder="Total Score"
                        value={trial.total_score || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "total_score", e.target.value)
                        }
                      />

                      <Input
                        type="date"
                        placeholder={`Trial Date ${trial.trial_no}`}
                        value={trial.trial_date || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "trial_date", e.target.value)
                        }
                      />

                      <Input
                        type="text"
                        placeholder={`Trial ${trial.trial_no} Id`}
                        value={trial.trial_id || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "trial_id", e.target.value)
                        }
                      />

                      <div className="mt-2">
                        <div className="font-semibold mb-1">
                          Subjects for Trial {trial.trial_no}
                        </div>

                        {(trial.subjects ?? []).map((subject, subjIndex) => (
                          <div key={subjIndex} className="flex gap-2 items-center mb-2">
                            <select
                              value={subject.subject_name || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_name",
                                  e.target.value
                                )
                              }
                              className="p-2 border rounded"
                            >
                              <option value="">Select subject</option>
                              {ACT1_SUBJECTS.map((s) => (
                                <option key={s.value} value={s.value}>
                                  {s.text}
                                </option>
                              ))}
                            </select>

                            <Input
                              type="number"
                              placeholder="Subject score"
                              value={subject.subject_score || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_score",
                                  e.target.value
                                )
                              }
                              className="p-2 border rounded w-36"
                            />

                            <Input
                              type="date"
                              placeholder="Subject date"
                              value={subject.subject_date || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_date",
                                  e.target.value
                                )
                              }
                              className="p-2 border rounded w-36"
                            />
                            <button
                              type="button"
                              onClick={() => handleRemoveSubject(trialIndex, subjIndex)}
                              className="px-2 py-1 bg-red-500 text-white rounded"
                            >
                              Remove
                            </button>
                          </div>
                        ))}

                        <button
                          type="button"
                          onClick={() => handleAddSubject(trialIndex)}
                          className="mt-2 px-3 py-1 bg-blue-500 text-white rounded"
                        >
                          + Add Subject
                        </button>
                      </div>
                    </div>
                  ))}
                  <Input
                    type="number"
                    placeholder="Number of Copies "
                    name="act1_copy_number"
                    onChange={handleInputChange}
                    value={studentData.act1_copy_number}
                  />
                </>
              )}{" "}
              {studentData.exam_name === "ACT1 One Trial Certificate" && (
                <>
                  {/* Debug Section - Show current trial_id values for One Trial Certificate */}
                  <div className="p-2 mb-4 bg-purple-100 border border-purple-400 rounded">
                    <h4 className="font-bold text-sm mb-2">Debug: One Trial Certificate Trial ID</h4>
                    <div className="text-xs">
                      {scoresToRender.slice(0, 1).map((trial, index) => (
                        <div key={index} className="mb-1">
                          Trial {trial.trial_no}: trial_id = "{trial.trial_id || 'empty'}"
                        </div>
                      ))}
                    </div>
                  </div>

                  {scoresToRender.slice(0, 1).map((trial, trialIndex) => (
                    <div key={trialIndex} className="p-2 border rounded bg-slate-300 mb-2">
                      <div className="font-medium mb-2">Trial {trial.trial_no}</div>

                      <Input
                        type="number"
                        placeholder="Total Score"
                        value={trial.total_score || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "total_score", e.target.value)
                        }
                      />

                      <Input
                        type="date"
                        placeholder={`Trial Date ${trial.trial_no}`}
                        value={trial.trial_date || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "trial_date", e.target.value)
                        }
                      />

                      <Input
                        type="text"
                        placeholder={`Trial ${trial.trial_no} Id`}
                        value={trial.trial_id || ""}
                        onChange={(e) =>
                          handleTrialChange(trialIndex, "trial_id", e.target.value)
                        }
                      />

                      <div className="mt-2">
                        <div className="font-semibold mb-1">
                          Subjects for Trial {trial.trial_no}
                        </div>

                        {(trial.subjects ?? []).map((subject, subjIndex) => (
                          <div key={subjIndex} className="flex gap-2 items-center mb-2">
                            <select
                              value={subject.subject_name || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_name",
                                  e.target.value
                                )
                              }
                              className="p-2 border rounded"
                            >
                              <option value="">Select subject</option>
                              {ACT1_SUBJECTS.map((s) => (
                                <option key={s.value} value={s.value}>
                                  {s.text}
                                </option>
                              ))}
                            </select>

                            <Input
                              type="number"
                              placeholder="Subject score"
                              value={subject.subject_score || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_score",
                                  e.target.value
                                )
                              }
                              className="p-2 border rounded w-36"
                            />

                            <Input
                              type="date"
                              placeholder="Subject date"
                              value={subject.subject_date || ""}
                              onChange={(e) =>
                                handleSubjectChange(
                                  trialIndex,
                                  subjIndex,
                                  "subject_date",
                                  e.target.value
                                )
                              }
                              className="p-2 border rounded w-36"
                            />
                            <button
                              type="button"
                              onClick={() => handleRemoveSubject(trialIndex, subjIndex)}
                              className="px-2 py-1 bg-red-500 text-white rounded"
                            >
                              Remove
                            </button>
                          </div>
                        ))}

                        <button
                          type="button"
                          onClick={() => handleAddSubject(trialIndex)}
                          className="mt-2 px-3 py-1 bg-blue-500 text-white rounded"
                        >
                          + Add Subject
                        </button>
                      </div>
                    </div>
                  ))}
                  <Input
                    type="number"
                    placeholder="Number of Copies "
                    name="act1_copy_number"
                    onChange={handleInputChange}
                    value={studentData.act1_copy_number}
                  />
                </>
              )}
              <div className="p-1 border rounded-lg">
                <Input
                  type="checkbox"
                  placeholder="ACT Subject"
                  name="act2"
                  required={false}
                  onChange={handleInputChange}
                  value={studentData.act2}
                />
                {studentData.act2 && (
                  <>
                    <Input
                      type="number"
                      placeholder="ACT subject 1 score"
                      name="act2_score1"
                      onChange={handleInputChange}
                      value={studentData.act2_score1}
                    />
                    <div className="m-2 flex items-center justify-center">
                      <label htmlFor="subject1" className="flex-auto">
                        <span className="text-red-600">*</span>
                        Subject 1:
                      </label>
                      <select
                        className="flex-initial p-2 ml-1 border rounded-xl focus:outline-blue-700"
                        onChange={handleInputChange}
                        name="subject1"
                        value={studentData.subject1}
                      >
                        {ACT_SUBJECTS.map((subject, i) => (
                          <option value={subject.value} key={i}>
                            {subject.text}
                          </option>
                        ))}
                      </select>
                    </div>
                    <Input
                      type="date"
                      placeholder="Trial Date 1"
                      name="act2_try_date1"
                      onChange={handleInputChange}
                      value={studentData.act2_try_date1}
                    />
                    <Input
                      required={false}
                      type="text"
                      placeholder="Trial 1 Id"
                      name="act2_try1_id"
                      onChange={handleInputChange}
                      value={studentData.act2_try1_id}
                    />
                    <Input
                      type="number"
                      placeholder="ACT subject 2 score"
                      name="act2_score2"
                      required={false}
                      onChange={handleInputChange}
                      value={studentData.act2_score2}
                    />
                    <div className="m-2 flex items-center justify-center">
                      <label htmlFor="subject2" className="flex-auto">
                        ACT subject 2:
                      </label>
                      <select
                        className="flex-initial p-2 ml-1 border rounded-xl focus:outline-blue-700"
                        onChange={handleInputChange}
                        name="subject2"
                        value={studentData.subject2}
                      >
                        {ACT_SUBJECTS.map((subject, i) => (
                          <option value={subject.value} key={i}>
                            {subject.text}
                          </option>
                        ))}
                      </select>
                    </div>
                    <Input
                      type="date"
                      required={false}
                      placeholder="Trial Date 2"
                      name="act2_try_date2"
                      onChange={handleInputChange}
                      value={studentData.act2_try_date2}
                    />
                    <Input
                      type="text"
                      placeholder="Trial 2 Id"
                      name="act2_try2_id"
                      onChange={handleInputChange}
                      value={studentData.act2_try2_id}
                      required={false}
                    />
                    <Input
                      type="number"
                      placeholder="ACT subject 3 score"
                      name="act2_score3"
                      required={false}
                      onChange={handleInputChange}
                      value={studentData.act2_score3}
                    />
                    <div className="m-2 flex items-center justify-center">
                      <label htmlFor="subject3" className="flex-auto">
                        ACT subject 3:
                      </label>
                      <select
                        className="flex-initial p-2 ml-1 border rounded-xl focus:outline-blue-700"
                        onChange={handleInputChange}
                        name="subject3"
                        value={studentData.subject3}
                      >
                        {ACT_SUBJECTS.map((subject, i) => (
                          <option value={subject.value} key={i}>
                            {subject.text}
                          </option>
                        ))}
                      </select>
                    </div>
                    <Input
                      placeholder="Trial Date 3"
                      type="date"
                      required={false}
                      name="act2_try_date3"
                      onChange={handleInputChange}
                      value={studentData.act2_try_date3}
                    />
                    <Input
                      type="text"
                      placeholder="Trial 3 Id"
                      name="act2_try3_id"
                      onChange={handleInputChange}
                      value={studentData.act2_try3_id}
                      required={false}
                    />
                    <Input
                      type="number"
                      placeholder="Number of Copies "
                      name="act2_copy_number"
                      onChange={handleInputChange}
                      value={studentData.act2_copy_number}
                    />
                  </>
                )}
              </div>
              <div className="p-1 mt-1 border rounded-lg">
                <Input
                  type="checkbox"
                  placeholder="MOE Authentication"
                  name="moe_auth"
                  required={false}
                  onChange={handleInputChange}
                  value={studentData.moe_auth}
                />
                {studentData.moe_auth && (
                  <Input
                    type="number"
                    placeholder="ACT 1 Number of Copies"
                    name="act1_moe_copy"
                    onChange={handleInputChange}
                    value={studentData.act1_moe_copy}
                  />
                )}
                {studentData.moe_auth & studentData.act2 ? (
                  <Input
                    type="number"
                    placeholder="ACT 2 Number of Copies"
                    name="act2_moe_copy"
                    onChange={handleInputChange}
                    value={studentData.act2_moe_copy}
                  />
                ) : null}
              </div>
            </div>
            <div className="p-1 dir-pthree border rounded">
              <h3 className="text-lg p-2">
                بيانات يجب ادخالها باللغة العربية:
              </h3>
              <Input
                type="text"
                placeholder="الاسم باللغة العربية"
                required={false}
                name="name_in_arabic"
                onChange={handleInputChange}
                value={studentData.name_in_arabic}
              />
              <Input
                type="text"
                placeholder="اسم المدرسة"
                required={false}
                name="school_in_arabic"
                onChange={handleInputChange}
                value={studentData.school_in_arabic}
              />
              <Input
                type="text"
                placeholder="الادارة التعليمية"
                required={false}
                name="educational_administration"
                onChange={handleInputChange}
                value={studentData.educational_administration}
              />
              <Input
                type="text"
                placeholder="اسم مركز الاختبار"
                required={false}
                name="center_test_arabic"
                onChange={handleInputChange}
                value={studentData.center_test_arabic}
              />
              <Input
                type="text"
                placeholder="بلد مركز الاختبار"
                required={false}
                name="center_test_country"
                onChange={handleInputChange}
                value={studentData.center_test_country}
              />
            </div>
          </div>
          <div className="flex flex-row-reverse justify-between">
            <Button
              color="bg-red-500 disabled:bg-gray-300"
              disabled={loading}
              text={
                !loading ? (
                  <>{pathname === "new" ? "Edit and Forward" : "Edit"}</>
                ) : (
                  <Loading />
                )
              }
            />
          </div>
        </form>
      </div>
    </div>
  );
}

function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  });
}
